import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody } from "reactstrap";

import { H3 } from "../../../../../AbstractElements";
import Divider from "../../../../../CommonElements/Divider";
import LearningPlanCard from "../../../../../container/LearningPlanCard";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../ReduxToolkit/Hooks";
import { getJobRoleList } from "../../../../../ReduxToolkit/Reducers/ManageMasterDataSlice";
import { SideBarTitleLearningPlans } from "../../../../../utils/Constant";
import { formatMinutes } from "../../../../../utils/helper/helper";

const LearningPlan = ({ learningPlans }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { jobRoleList } = useAppSelector(state => state.manageMasterData);
  const [transformedData, setTransformedData] = useState({});

  useEffect(() => {
    dispatch(getJobRoleList());
  }, [dispatch]);

  useEffect(() => {
    if (jobRoleList?.job_role && Array.isArray(jobRoleList?.job_role)) {
      const result = jobRoleList.job_role.reduce((acc, item) => {
        acc[item.id] = {
          name: item.name,
          industry_name: item.industry_name,
        };
        return acc;
      }, {});
      setTransformedData(result);
    }
  }, [jobRoleList]);

  const handleClick = id => {
    navigate(`/master-data/learning-plan-detail?id=${id}`);
  };

  const extractJobRoleName = ids =>
    ids?.map(id => transformedData[id]?.name || null);

  return (
    <Card>
      <CardBody className="mt-2">
        <H3 className="fw-bold">{SideBarTitleLearningPlans}</H3>
        <Divider />
        <div className="learning-plan-grid">
          {learningPlans?.map((item, ind) => {
            return (
              <div key={ind} onClick={() => handleClick(item.id)}>
                <LearningPlanCard
                  key={item.id}
                  id={item.id}
                  planType={item?.level}
                  title={item?.name}
                  creator={extractJobRoleName(item?.job_roles)}
                  totalDuration={formatMinutes(item?.duration)}
                  learnersCount={item?.users}
                  groupsCount={item?.user_groups}
                  thumbnailUrl={item?.thumbnail_url}
                  isArchived={false}
                  courses={item?.courses}
                  assessments={item?.assessments}
                  showDrop
                  userGroupPlan
                />
              </div>
            );
          })}
        </div>
      </CardBody>
    </Card>
  );
};

LearningPlan.propTypes = {
  learningPlans: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      level: PropTypes.string,
      name: PropTypes.string,
      job_roles: PropTypes.string,
      duration: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      learner_count: PropTypes.number,
      group_count: PropTypes.number,
      thumbnailUrl: PropTypes.string,
      courses: PropTypes.array,
      assessments: PropTypes.array,
    })
  ),
};

export default LearningPlan;
